import { DefaultUser, IUser } from 'src/Definitions';
import { IUserDto } from 'src/generated_client';

function addDefaultUserFields(user: IUserDto): IUser {
    return { ...DefaultUser(), ...user };
}

export default addDefaultUserFields;



// WEBPACK FOOTER //
// ./src/utils/addDefaultUserFields.ts